
    import React from 'react';
    import SpriteSymbol from "svg-baker-runtime/browser-symbol";
    import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
    import SpriteSymbolComponent from "../src/Icon.js";
    
    const symbol = new SpriteSymbol({
  "id": "arrow-left",
  "use": "arrow-left-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"arrow-left\"><path d=\"M21.717 2q.357 0 .633.281l1.374 1.403q.276.281.276.646 0 .364-.276.645L12.921 16l10.803 11.025q.276.28.276.645t-.276.646l-1.374 1.403q-.276.281-.633.281t-.633-.281L8.276 16.647Q8 16.366 8 16.002q0-.365.276-.646L21.084 2.284q.276-.28.633-.28z\" /></symbol>"
});
    sprite.add(symbol);

    export default class ArrowLeftSpriteSymbolComponent extends React.Component {
      render() {
        return <SpriteSymbolComponent glyph="arrow-left" {...this.props} />;
      }
    }
  